
import { Component, Emit, Prop, Vue } from "nuxt-property-decorator";
import RouterLink from "~/components/atoms/text/RouterLink.vue";

@Component({
  components: {
    RouterLink,
  },
})
export default class AlphabetNavigation extends Vue {
  @Prop({ required: true }) private basePath!: string;
  @Prop({ default: false }) private suppressActiveLink?: boolean;
  @Emit()
  private letterClicked(letter: string) {
    return letter;
  }

  private alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
}
